import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { OrarioPage } from '../../pages/orario/orario';

/**
 * Generated class for the EditorarioPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-editorario',
  templateUrl: 'editorario.html',
})
export class EditorarioPage {
 
  today;
  selDay;
  orario;
  orari;
  
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,

  ) {
    this.orario=navParams.get('orario');
    this.orari = navParams.get('orari');

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditorarioPage');
    console.log('orari:'+JSON.stringify(this.orari))


    
  }
  updateOrario(){
    console.log('orario:'+JSON.stringify(this.orario))
    this.rest.aggiornaGiornoConsegna(this.orario);
    this.navCtrl.push(OrarioPage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 1, 2); });

  }
}



// WEBPACK FOOTER //
// ./src/pages/editorario/editorario.ts